export const TEST_ID = 'activityCardHeader';
